import Cookies from "js-cookie";

// TODO: 시연용 계정-학교 고정 매핑.
// 추후 관리자 → 담당 그룹 → 소속 학교 정보를 API에서 받아오는 구조로 교체한다.
// 클라이언트 조회 제한이며 서버의 인증/인가를 대체하지 않는다.
const SCHOOL_ADMIN_CONFIG = Object.freeze({
  "haeundae@dincon.co.kr": Object.freeze({ schoolName: "해운대중학교" }),
  "hyorim@dincon.co.kr": Object.freeze({
    schoolName: "효림초등학교",
    manageStartMonth: "2026-03"
  })
});

export function getAdminScope() {
  const loginId = String(Cookies.get("u_id") || "")
    .trim()
    .toLowerCase();
  const config = SCHOOL_ADMIN_CONFIG[loginId];
  return Object.freeze({
    restricted: !!config,
    loginId,
    schoolName: config?.schoolName || "",
    manageStartMonth: config?.manageStartMonth || ""
  });
}

export function scopedSchoolName(requested = "") {
  const scope = getAdminScope();
  return scope.restricted ? scope.schoolName : requested;
}

export function filterSchoolRows(rows, schoolField = "school_name") {
  const scope = getAdminScope();
  if (!scope.restricted) return rows;
  return (Array.isArray(rows) ? rows : []).filter(
    (row) => String(row?.[schoolField] || "").trim() === scope.schoolName
  );
}

export function filterMemberRows(rows) {
  const scope = getAdminScope();
  if (!scope.restricted) return rows;
  return (Array.isArray(rows) ? rows : []).filter(
    (row) =>
      String(row?.u_id || "")
        .trim()
        .toLowerCase() === scope.loginId
  );
}
